export const EVENT_CONSTANTS = {
    LOAN_CALCULATOR_CDP_ACTION: "Loan_calculator_CDP_action",
    CARD_VIEWED: "Card_viewed",
    IMPERFECTION_SEEN: "car imperfection section seen",
    CALCULATOR_SECTION_SEEN: "loan calculator section seen",
    TRADE_IN_BANNER_CTA_CLICKED: "trade in banner cta clicked",
    TRADE_IN_BANNER_ACTION: "clicked",
    CHECKOUT_INITIATED: "TD_Flow"
};

export const EVENT_DATA = {
    LOAN_CALCULATOR_CDP_ACTION: {
        eventCategory: "CDP Desktop variant B",
        eventAction: "Loan_calculator_CDP_action",
        eventLabel: "Calculator_CDP_clicked",
        event: "custom_event"
    },
    CARD_VIEWED: {
        eventCategory: "CDP Desktop variant B",
        eventAction: "Card_viewed",
        eventLabel: "{{Finance_CDP}}",
        event: "custom_event"
    },
    TRADE_IN_BANNER_ACTION: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "clicked",
        eventLabel: "trade_in_banner"
    },
    CHECKOUT_INITIATED: {
        eventCategory: "checkout_initiated",
        eventAction: "TD_Flow",
        eventLabel: "No",
        event: "checkout"
    }
};
